import { mapGetters } from 'vuex'
import Container from '@/components/Container/Container'
import Map from '@/components/Map/Map'
import Spinner from '@/components/Spinner/Spinner'
import FieldHorizontal from '@/components/FieldHorizontal/FieldHorizontal'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Session',
  components: {
    Container,
    FieldHorizontal,
    FontAwesomeIcon,
    Map,
    Spinner
  },
  computed: {
    ...mapGetters({
      mapLoading: 'mapLoading',
      isLoading: 'sessionsLoading',
      error: 'sessionsError',
      session: 'session',
      vehicle: 'vehicle',
      sessionData: 'sessionData'
    })
  },
  created() {
    const sessionId = this.$route.params.id
    this.getSession(sessionId)
  },
  methods: {
    getSession(sessionId) {
      this.$store.dispatch('getSession', sessionId).then(session => {
        this.$store.dispatch('getVehicle', session.engine.vehicle.id)
        this.$store.dispatch('getSessionStatistics', { session: session.sessionid })
        this.$store.dispatch('getSessionData', { session: session.sessionid })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Session/script.js